import { put, takeLatest } from 'redux-saga/effects';
import appActions from '../../../appActions';
import { crudSaga, querySaga } from '../../../utils/reduxHelper';

function* resetRolesSaga() {
    yield put(appActions.ROLES_RESET_SUCCESS());
}

function* watchPropConfigUpdateRequest() {
    yield takeLatest(
        appActions.ROLES_UPDATE_REQUEST.type,
        function* (action) {
            yield* crudSaga(
                action,
                'sys/propconfig',
                appActions.ROLES_UPDATE_SUCCESS,
                appActions.ROLES_UPDATE_FAILURE,
                'PUT',
            );
        },
    );
}

// function* watchPropConfigCreateRequest() {
//     yield takeLatest(
//         appActions.ROLES_CREATE_REQUEST.type,
//         function* (action) {
//             yield* crudSaga(
//                 action,
//                 'sys/propconfig',
//                 appActions.ROLES_CREATE_SUCCESS,
//                 appActions.ROLES_CREATE_FAILURE,
//                 'POST',
//             );
//         },
//     );
// }

// function* watchPropConfigDeleteRequest() {
//     yield takeLatest(
//         appActions.ROLES_DELETE_REQUEST.type,
//         function* (action) {
//             yield* crudSaga(
//                 action,
//                 'sys/propconfig',
//                 appActions.ROLES_DELETE_SUCCESS,
//                 appActions.ROLES_DELETE_FAILURE,
//                 'DELETE',
//             );
//         },
//     );
// }

function* watchPropConfigGetAllRequest() {

    yield takeLatest(
        appActions.ROLES_GET_ALL_REQUEST.type,
        function* (action) {
            yield* querySaga(
                action,
                'sys/propconfig',
                appActions.ROLES_GET_ALL_SUCCESS,
                appActions.ROLES_GET_ALL_FAILURE,
            );
        },
    );
}

export default function* rolesWatcher() {
   yield* watchPropConfigUpdateRequest();
   // yield* watchPropConfigCreateRequest();
    yield* watchPropConfigGetAllRequest();
  //  yield* watchPropConfigDeleteRequest();
    yield takeLatest(
        appActions.ROLES_RESET_REQUEST.type,
        resetRolesSaga,
    );
    // Add other watchers here
}
